import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { pointerEventsStyles } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarCtaContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return <View style={[styles.container, pointerEventsStyles['box-none']]}>{children}</View>;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const NAVBAR_CTA_MIN_WIDTH = 100;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    minWidth: NAVBAR_CTA_MIN_WIDTH,
  },
});
